import { PREFIX_URL_API } from '@/shared/constants';
import { apiClient } from '@/shared/utils/apiClient';

export const getBasketPreiew = (): Promise<string> => {
  const url = `${PREFIX_URL_API.CHECKOUT}/BasketPreview`;
  return apiClient.post<string>(url);
};
